import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useMutation } from "react-query";
import TextInputs from "../../../../components/atoms/Inputs/TextInputs";
import Modal from "../../../../components/molecures/Modals/Modal";
import InputLines from "../../../../components/molecures/InputLines";
import useModals from "../../../../hooks/useModals";
import { resetPass } from "../../../../apis/UserInfo/apis";
import { StatusType } from "../../../../components/atoms/Explain/types";
import { ALERT_MESSAGE } from "../../../../components/constants";
import { HttpError } from "../../../../network/types";
import { alertError, validatePass } from "../../../../shared/utils";

const ChangePassModal: React.FC = () => {
  const ResetPasswordMutation = useMutation(resetPass, {
    onSuccess: () => {
      closeModal();
      openAlertModal({
        contents: "성공적으로 비밀번호가 변경되었습니다.",
        title: "비밀번호 변경 성공 ",
      });
    },
    onError: (err: HttpError) => {
      setStatus({
        ...status,
        password: { status: "error", explain: err.message },
      });
      alertError(err.message);
      closeModal();
    },
  });
  const { resetModal, openConfirmModal, openAlertModal, closeModal } =
    useModals();
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [rePass, setRepass] = useState("");
  const [status, setStatus] = useState<{
    password: { status?: StatusType; explain?: string };
    newPassword: { status?: StatusType; explain?: string };
    rePass: { status?: StatusType; explain?: string };
  }>({
    password: { status: undefined, explain: undefined },
    newPassword: { status: undefined, explain: undefined },
    rePass: { status: undefined, explain: undefined },
  });
  const onOk = () => {
    openConfirmModal({
      contents: "비밀번호를 변경하시겠습니까?",
      title: "비밀번호 변경",
      onOk: () => ResetPasswordMutation.mutate({ password, newPassword }),
    });
  };
  useEffect(() => {
    const passMessages = validatePass(newPassword);
    if (rePass !== newPassword) {
      setStatus({
        ...status,
        newPassword: {
          status:
            newPassword.length === 0
              ? undefined
              : passMessages.length === 0
              ? "success"
              : "error",
          explain:
            newPassword.length === 0
              ? undefined
              : passMessages.length === 0
              ? undefined
              : passMessages.join(" "),
        },
      });
    }
  }, [newPassword, rePass]);
  const isOkdisabled =
    newPassword === "" ||
    rePass === "" ||
    newPassword !== rePass ||
    validatePass(newPassword).length !== 0;
  return (
    <Modal
      width={700}
      onCancel={resetModal}
      onAdditional={resetModal}
      onOk={onOk}
      isOkDisabled={isOkdisabled}
      title="비밀번호 변경"
    >
      <ModalContainer>
        <InputLines margin="24px" alignStart isFill title="현재 비밀번호">
          <TextInputs
            maxLength={30}
            isPassword
            value={password}
            status={status.password.status}
            explain={status.password.explain}
            onChange={(e) => {
              setPassword(e);
              setStatus({
                ...status,
                password: { status: undefined, explain: undefined },
              });
            }}
            placeholder="현재 비밀번호"
          />
        </InputLines>
        <InputLines margin="24px" alignStart isFill title="새 비밀번호">
          <TextInputs
            isPassword
            maxLength={30}
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e);
              setStatus({
                ...status,
                password: { status: undefined, explain: undefined },

                newPassword: { status: undefined, explain: undefined },
              });
            }}
            status={status.newPassword.status}
            explain={status.newPassword.explain}
            placeholder="새 비밀번호"
          />
        </InputLines>
        <InputLines margin="24px" alignStart isFill title="새 비밀번호 확인">
          <TextInputs
            isPassword
            value={rePass}
            onChange={(e) => {
              setRepass(e);
              setStatus({
                ...status,
                rePass: {
                  status: newPassword !== e ? "error" : undefined,
                  explain:
                    newPassword !== e
                      ? ALERT_MESSAGE.INVALID_REPASS
                      : undefined,
                },
              });
            }}
            isNotShowPassword
            onPressEnter={isOkdisabled ? undefined : onOk}
            placeholder="새 비밀번호 확인"
            status={status.rePass.status}
            explain={status.rePass.explain}
          />
        </InputLines>
      </ModalContainer>
    </Modal>
  );
};

export default ChangePassModal;

const ModalContainer = styled.div`
  padding: 24px 24px 0px 24px;
  width: 100%;
`;
